export default __webpack_public_path__ + "static/media/marilene-vieira-book.fa622e9b.png";